














































import TableCell from './TableCell.vue'

export default {
  components: { TableCell },
  props: {
    linkTo: { type: String, default: null },
    expandingHeight: { type: Number, default: 96 },
    onBeforeExpanded: { type: Function, default: () => {} }
  },
  data() {
    return {
      isRowExpanded: false
    }
  },
  computed: {
    expandable() {
      return Boolean(this.$slots.expanding)
    },
    clickableComponentName() {
      return this.linkTo ? 'router-link' : 'div'
    },
    clickableComponentClass() {
      return this.linkTo ? 'clickable' : ''
    },
    expandingComponentStyles() {
      return {
        '--expandingHeight': `${this.expandingHeight}px`
      }
    }
  },
  methods: {
    async toggleRowExpanded() {
      /* 
        I planned to execute onBeforeExpanded function
        in the parent component to keep all the logic away the TableRow,
        but I've found no good way to wait for the promise 
        before expanding the row by using emit only
      */
      if (!this.isRowExpanded) await this.onBeforeExpanded()
      this.isRowExpanded = !this.isRowExpanded
    }
  }
}
